import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/utils/datetime";
import "@/utils/tenant";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Registro do Service Worker (PWA instalável).
// Apenas em produção: em dev o cache atrapalharia o hot reload.
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}
